import * as z from "zod/v4";
import { aeoDashboardFilterInput } from "./types";

const topicEntry_ = z.object({
  topicId: z.string(),
  name: z.string(),
  color: z.string().nullable(),
  mentions: z.number().int(),
  sov: z.number(),
  visibility: z.number(),
  rank: z.number().int(),
});

export const getAeoDashboardTopics = {
  name: "getAeoDashboardTopics" as const,
  input: aeoDashboardFilterInput,
  output: z.object({ topics: z.array(topicEntry_) }),
};
